import Ajax from '../components/ajax'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { userLogin } from '../store/slices/mainSlices'
import React, { useCallback, useEffect, useState } from 'react'

import editIcon from '../images/edit.png'
import deleteIcon from '../images/delete.png'

export default function Rooms({ setModalRooms, modalRooms, roomsAjax, setRoomsAjax, setRoomsList, roomsList, titleBranch }) {
  //Initialization state manager
  const dispatch = useDispatch()
  const [roomsMain, setRoomsMain] = useState(false)
  const [currentRoomsId, setCurrentRoomsId] = useState(false)

  //Form for rooms
  const {
    register: registerRooms,
    handleSubmit: handleSubmitRooms,
    setValue: setValueRooms,
    reset: resetRooms,
    formState: { errors: errorsRooms, isValid: isValidRooms },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      roomsValues: {
        name: '',
        address: '',
        seats: '',
        tables: '',
        chairs: '',
        projector: '0',
        description: '',
      },
    },
    reValidateMode: 'onChange',
  })

  //Request for edit Rooms
  const oneRooms = useCallback(
    event => {
      const sendButtonRooms = document.querySelector('.sendButtonRooms')
      sendButtonRooms.setAttribute('data-rooms', 'true')
      const ajaxUrl = 'manager/rooms/getOne'
      const ajaxBody = {
        id: event.target.dataset.value,
        branch_id: roomsAjax.branch_id,
      }
      setCurrentRoomsId(event.target.dataset.value)
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const resultArray = data.data
          const newEditArray = Object.keys(data.data)
          for (const key of newEditArray) {
            if (resultArray[key] === null) {
              resultArray[key] = ''
            }
          }
          setValueRooms(
            'roomsValues',
            {
              name: resultArray.name,
              address: resultArray.address,
              seats: resultArray.seats_nr,
              tables: resultArray.tables_nr,
              chairs: resultArray.chairs_nr,
              projector: resultArray.projector,
              description: resultArray.description,
            },
            { shouldValidate: true }
          )
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [roomsAjax.branch_id, setValueRooms, dispatch]
  )

  //Request for add new Employer
  const onSubmitSave = data => {
    const sendButtonRooms = document.querySelector('.sendButtonRooms')
    if (sendButtonRooms.dataset.rooms === 'true') {
      const ajaxUrl = 'manager/rooms/update'
      const ajaxBody = {
        id: currentRoomsId,
        branch_id: roomsAjax.branch_id,
        name: data.roomsValues.name,
        address: data.roomsValues.address,
        seats_nr: data.roomsValues.seats,
        tables_nr: data.roomsValues.tables,
        chairs_nr: data.roomsValues.chairs,
        projector: data.roomsValues.projector,
        description: data.roomsValues.description,
      }

      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const newArrayEmployers = roomsList.slice()
          const currentEditEmployer = newArrayEmployers.indexOf(newArrayEmployers.find(child => child.id === Number(ajaxBody.id)))
          newArrayEmployers[currentEditEmployer] = ajaxBody
          setRoomsList(newArrayEmployers)
          resetRooms()
          sendButtonRooms.setAttribute('data-rooms', 'false')
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    } else {
      const ajaxUrl = 'manager/rooms/add'
      const ajaxBody = {
        branch_id: roomsAjax.branch_id,
        name: data.roomsValues.name,
        address: data.roomsValues.address,
        seats_nr: data.roomsValues.seats,
        tables_nr: data.roomsValues.tables,
        chairs_nr: data.roomsValues.chairs,
        projector: data.roomsValues.projector,
        description: data.roomsValues.description,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          resetRooms()
          const newRooms = {
            id: data.data.id,
            name: data.data.name,
            address: data.data.address,
            seats_nr: data.data.seats_nr,
            tables_nr: data.data.tables_nr,
            chairs_nr: data.data.chairs_nr,
            projector: data.data.projector,
            description: data.data.description,
          }
          const newArrayRooms = roomsList.slice()
          newArrayRooms.unshift(newRooms)
          setRoomsList(newArrayRooms)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    }
  }

  //Request for delete Employer
  const deleteEmployer = useCallback(
    event => {
      const ajaxUrl = 'manager/rooms/delete'
      const ajaxBody = {
        id: event.target.dataset.value,
        branch_id: event.target.closest('.item').dataset.branch,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const newDeleteArray = roomsList.slice()
          const indexDelete = newDeleteArray.indexOf(newDeleteArray.find(child => child.id === Number(event.target.dataset.value)))
          newDeleteArray.splice(indexDelete, 1)
          setRoomsList(newDeleteArray)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [roomsList, setRoomsList, dispatch]
  )

  //Request for all Employers
  useEffect(() => {
    if (!modalRooms) {
      setRoomsList(false)
      setRoomsAjax(false)
    }
    if (roomsList) {
      setRoomsMain(
        Object.values(roomsList).map(child => {
          return (
            <div className='item' key={child.id} data-branch={child.branch_id}>
              <p title={child.name}>{child.name}</p>
              <p title={child.address}>{child.address}</p>
              <p title={child.seats_nr}>{child.seats_nr}</p>
              <p title={child.tables_nr}>{child.tables_nr}</p>
              <p title={child.chairs_nr}>{child.chairs_nr}</p>
              <p>{child.projector === '1' ? 'Yes' : 'No'}</p>
              <p title={child.description}>{child.description}</p>
              <div className='itemButtons'>
                <button data-value={child.id} onClick={event => oneRooms(event)}>
                  <img src={editIcon} alt='edit icon' data-value={child.id} />
                </button>
                <button data-value={child.id} onClick={event => deleteEmployer(event)}>
                  <img src={deleteIcon} alt='delete icon' data-value={child.id} />
                </button>
              </div>
            </div>
          )
        })
      )
    }
  }, [roomsList, modalRooms, deleteEmployer, setRoomsList, oneRooms, setRoomsAjax])

  return (
    <section className='rooms'>
      <div className='roomsTable'>
        <div className='addNew'>
          <h2>{titleBranch}</h2>
          <button
            value='addNew'
            onClick={function () {
              resetRooms()
              const sendButtonRooms = document.querySelector('.sendButtonRooms')
              sendButtonRooms.setAttribute('data-rooms', 'false')
            }}>
            Add
          </button>
        </div>
        <div className='currentTable'>
          <div className='item title'>
            <h2>Name</h2>
            <h2>Address</h2>
            <h2>Seats</h2>
            <h2>Tables</h2>
            <h2>Chairs</h2>
            <h2>Projector</h2>
            <h2>Description</h2>
            <div className='itemButtons'></div>
          </div>
          {roomsMain}
        </div>
      </div>
      <div className='roomsEdit'>
        <h2>Rooms info</h2>
        <form autoComplete='off' onSubmit={handleSubmitRooms(onSubmitSave)}>
          <div>
            <div className='labelDiv'>
              <label>
                <p>
                  Name <span className='requiredInput'>*</span>
                </p>
                <input
                  {...registerRooms('roomsValues.name', {
                    required: 'This field is required',
                    minLength: {
                      value: 3,
                      message: 'Min length 3',
                    },
                    maxLength: {
                      value: 50,
                      message: 'Max length 50',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('name')
                  ? errorsRooms.roomsValues.name.message
                  : null}
              </span>
            </div>
            <div className='labelDiv'>
              <label>
                <p>
                  Address <span className='requiredInput'>*</span>
                </p>
                <input
                  {...registerRooms('roomsValues.address', {
                    required: 'This field is required',
                    minLength: {
                      value: 3,
                      message: 'Min length 3',
                    },
                    maxLength: {
                      value: 50,
                      message: 'Max length 50',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('address')
                  ? errorsRooms.roomsValues.address.message
                  : null}
              </span>
            </div>
          </div>
          <div>
            <div className='labelDiv'>
              <label>
                Seats
                <input
                  type='number'
                  {...registerRooms('roomsValues.seats', {
                    maxLength: {
                      value: 100,
                      message: 'Max length 50',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('seats')
                  ? errorsRooms.roomsValues.seats.message
                  : null}
              </span>
            </div>
            <div className='labelDiv'>
              <label>
                Tables
                <input
                  type='number'
                  {...registerRooms('roomsValues.tables', {
                    maxLength: {
                      value: 100,
                      message: 'Max length 50',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('tables')
                  ? errorsRooms.roomsValues.tables.message
                  : null}
              </span>
            </div>
          </div>
          <label>
            <p>Chairs</p>
            <input
              {...registerRooms('roomsValues.chairs', {
                maxLength: {
                  value: 100,
                  message: 'Max length 50',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('chairs')
              ? errorsRooms.roomsValues.chairs.message
              : null}
          </span>
          <label>
            Projector
            <select
              {...registerRooms('roomsValues.projector', {
                required: 'This field is required',
              })}>
              <option value='0'>No</option>
              <option value='1'>Yes</option>
            </select>
          </label>
          <span className='errorResponse'>
            {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('projector')
              ? errorsRooms.roomsValues.projector.message
              : null}
          </span>
          <label>
            Description
            <textarea
              {...registerRooms('roomsValues.description', {
                maxLength: {
                  value: 500,
                  message: 'Max length 500',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errorsRooms.hasOwnProperty('roomsValues') && errorsRooms.roomsValues.hasOwnProperty('description')
              ? errorsRooms.roomsValues.description.message
              : null}
          </span>
          <div className='buttons'>
            <input type='submit' className='sendButton sendButtonRooms' value='Save' disabled={!isValidRooms} />
            <span className='sendButton' onClick={() => setModalRooms(false)}>
              Cancel
            </span>
          </div>
        </form>
      </div>
    </section>
  )
}
